<template>
  <div id="shopping-list">
      <div class="top-nav">
          <v-btn text @click="$router.go(-1)">
              <v-icon>arrow_back</v-icon> Back
          </v-btn>
      </div>

      <div class="shopping-list-container">
          <div class="shopping-list-title pt-3 mb-5 ml-md-0">Week {{ $route.params.week | leadingZero}} Shopping List</div>
      </div>
          <shopping-list-display></shopping-list-display>
  </div>
</template>

<script>

  import { mapState } from 'vuex'

  import ShoppingList from '../plugins/bft-nutrition-plugin/components/ShoppingList'

  export default {
      components: {'shopping-list-display': ShoppingList},
    mounted() {
        this.$store.dispatch('nutrition/loadShoppingList', this.$route.params.week)
    },
      created() {
          this.unwatch = this.$store.watch(
              (state, getters) => getters['ShoppingList/shopping_list'],
              (newValue, oldValue) => {
                  if(oldValue) this.$store.dispatch('nutrition/updateCheckedShoppingList', this.$route.params.week)
              },{ deep: true }
          )
      },
      beforeDestroy() {
          this.unwatch()
      },
    name: "ShoppingList",
      filters: {
          leadingZero: function (value) {
              var s = value + ""
              while (s.length < 2) s = "0" + s
              return s
          }
      },
    methods: {
      onCheck(newValue, item) {
        //console.log(newValue, item)
        this.$store.dispatch('nutrition/setShoppingItem', {value: newValue, item: item, week: this.$route.params.week})
      },
      checkValue(item) {
        if(!this.checked_shopping_list || !this.checked_shopping_list[this.stream] || !this.checked_shopping_list[this.stream][this.$route.params.week]) return false
        return this.checked_shopping_list[this.stream][this.$route.params.week].indexOf(item) >= 0
      }
    },
    computed: {
      ...mapState({
        selectedWeek: state => state.nutrition.selectedWeek,
        shopping_list: state => state.ShoppingList.shopping_list,
        checked_shopping_list: state => state.nutrition.checked_shopping_list,
        stream: state => state.challenge.selected_stream
      }),
      list () {
        return this.shopping_lists[this.$route.params.week]
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../scss/variables';

  .shopping-list {
    &-title {
      text-transform: uppercase;
      font-size: 20px;
      font-weight: bold;
      color: $primary;
        margin-left: 20px;
        @media only screen and (min-width:768px) {
            margin-left: 0;
        }

    }

    &-category {
      margin: 25px 0 5px;
      font-weight: bold;
      text-transform: uppercase;
    }
    &-items {
      color: #787874;
      padding-left: 0;

      li {
        list-style: none;
      }
    }
    &-notes {
      margin-top: 20px;
      font-style: italic;
      font-size: 12px;
    }

  }
</style>


